import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalizationDatePipe } from './localization-date.pipe';
import { LocalizationPipe } from './localization.pipe';
import { ValueToLabelPipe } from './value-to-label.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        LocalizationPipe,
        ValueToLabelPipe,
        LocalizationDatePipe,
    ],
    exports: [
        LocalizationPipe,
        ValueToLabelPipe,
        LocalizationDatePipe,
    ]
})
export class PipesModule {}